import styled from "styled-components";

/**
 * 依頼画面のスタイルコンポーネント
 * 元のPHPデザインを参考に作成
 */
const IraiStyles = {
  //
  NoteRed: styled.span`
    color: #ff0000;
    font-size: 14px;
    font-weight: normal;
  `,
  // メインコンテナ
  IraiContainer: styled.div`
    width: 1340px;
    padding: 25px;
    background-color: white;
    border: 5px solid #ccc;
    margin: 0;
    overflow: auto;
  `,

  // タイトル
  Title: styled.h2`
    background: url("/images/window_title.png") no-repeat 0 50%;
    padding: 5px 0 0 35px;
    color: #333;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 10px;
    font-weight: bold;
  `,

  // 赤いインライン
  RedInline: styled.span`
    font-size: 12pt;
    font-weight: normal;
    color: #ff0000;
  `,

  // 詳細テーブル（車輌情報用）
  DetailTable: styled.table`
    width: 100%;
    border: 1px solid #999;
    margin-bottom: 5px;
    table-layout: fixed;

    caption {
      background: #999;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      padding: 2px 5px;
    }

    th {
      background: #e4e4e4;
      font-size: 14px;
      font-weight: bold;
      padding: 5px;
      border-width: 1px 0 1px 1px;
      border-color: #999;
      border-style: solid;
      text-align: right;
      color: #333;
      width: 8em;
      vertical-align: middle;
    }

    td {
      background: #fff;
      font-size: 14px;
      padding: 5px;
      border-width: 1px 1px 1px 0;
      border-color: #999;
      border-style: solid;
      text-align: left;
      color: #333;
      vertical-align: middle;
    }
  `,

  // 通常テーブル（依頼者情報・自社管理情報用）
  NormalTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0px;
    font-size: 14px;
    text-align: center;

    caption {
      background: #3366ff;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      padding: 2px 5px;
    }
    &.kyoto-seibi caption {
      background: #00b200;
    }

    th {
      background: #bccdff;
      font-size: 14px;
      font-weight: bold;
      padding: 5px;
      border: 1px solid #333;
      text-align: right;
      color: #333;
      width: 8em;
      vertical-align: middle;
      white-space: nowrap;
    }
    &.kyoto-seibi th {
      background: #99ffa3;
    }

    td {
      background: #fff;
      font-size: 14px;
      padding: 5px;
      border: 1px solid #333;
      text-align: center;
      color: #333;
      vertical-align: middle;
      word-break: break-word;
    }

    td.left {
      text-align: left;
    }
  `,

  // ボーダーレステーブル（ボタン用）
  BorderlessTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 10px;

    td {
      border: none;
      padding: 0px;
    }
  `,

  // 重要ボタン
  ImportantBtn: styled.input`
    background: #3366ff url(/images/arrow_important.png) no-repeat 10px 50%;
    color: #fff;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #99ccff #1c3dc0 #1c3dc0 #99ccff;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight: bold;
    padding: 0 10px 0 30px;
    cursor: pointer;

    &:hover {
      background: #1c3dc0;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      opacity: 0.6;
    }
      
    &.kyoto-seibi {
      background: #5fbf00 url("/images/arrow_important.png") no-repeat 10px 50%;
      border-color: #ecffe5 #089308 #089308 #ecffe5;
      color: #FFF;
      &:hover {
        filter: brightness(0.95);
      }
    }
  `,

  // ダミーボタン
  DummyButton: styled.input`
    background: #28a745;
    color: #fff;
    height: 33px;
    border: 1px solid #1e7e34;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 14px;
    font-weight: bold;
    padding: 0 10px;
    cursor: pointer;

    &:hover {
      background: #1e7e34;
    }
  `,

  // グレーボタン
  BtnGray: styled.a`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #ccc;
    }

    &.disable-btn {
      background-color: #d4d4d4 !important;
      border-color: #e8e8e8 #aaa #aaa #e8e8e8 !important;
      color: #fff !important;
      cursor: default;
    }
  `,

  // フォーム入力フィールド
  FormInput: styled.input`
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: #3366ff;
      box-shadow: 0 0 5px rgba(51, 102, 255, 0.3);
    }
  `,

  // テキストエリア
  Textarea: styled.textarea`
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;

    &:focus {
      outline: none;
      border-color: #3366ff;
      box-shadow: 0 0 5px rgba(51, 102, 255, 0.3);
    }
  `,

  // セレクトボックス
  Select: styled.select`
    width: 100%;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: #3366ff;
      box-shadow: 0 0 5px rgba(51, 102, 255, 0.3);
    }
  `,

  // ラベル
  Label: styled.label`
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
    color: #333;
  `,

  // フォームグループ
  FormGroup: styled.div`
    margin-bottom: 15px;
  `,

  // エラーメッセージ
  ErrorMessage: styled.div`
    color: #ff0000;
    font-size: 12px;
    margin-top: 5px;
  `,

  // 警告メッセージ
  WarningMessage: styled.div`
    color: #ff0000;
    font-size: 14px;
    font-weight: bold;
    margin: 10px 0;
    padding: 10px;
    background-color: #fff5f5;
    border: 1px solid #ffcccc;
    border-radius: 5px;
  `,

  // 情報メッセージ
  InfoMessage: styled.div`
    color: #0066cc;
    font-size: 14px;
    margin: 10px 0;
    padding: 10px;
    background-color: #f0f8ff;
    border: 1px solid #b3d9ff;
    border-radius: 5px;
  `,

  // 成功メッセージ
  SuccessMessage: styled.div`
    color: #008000;
    font-size: 14px;
    margin: 10px 0;
    padding: 10px;
    background-color: #f0fff0;
    border: 1px solid #ccffcc;
    border-radius: 5px;
  `,

  // 必須マーク
  MustImg: styled.img`
    vertical-align: middle;
    float: right;
    width: 12px;
    height: 12px;
  `,

  // 写真グリッド行
  PhotoGridRow: styled.tr`
    &:nth-child(even) {
      background-color: #f9f9f9;
    }
  `,

  // 写真セル
  PhotoCell: styled.td`
    text-align: center;
    width: 252px;
    padding: 10px;
    border: 1px solid #ccc;
  `,

  // 部品ミニ
  PartsMini: styled.div`
    width: 180px;
    margin: 0 auto;
  `,

  // 写真ドロップエリア
  PhotoDrop: styled.div`
    height: 144px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
    border-radius: 5px;

    img {
      max-height: 140px;
      max-width: 100%;
    }

    &:hover {
      border-color: #3366ff;
      background-color: #f0f8ff;
    }
  `,

  // ミニ右ボックス
  MiniRightBox: styled.div`
    margin-top: 6px;
  `,

  // ファイルマスク
  FileMask2: styled.label`
    display: inline-block;
    cursor: pointer;
  `,

  // ファイルマスクスパン
  FileMask2Span: styled.span`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border-style: solid;
    border-width: 1px;
    border-color: #eee #999 #999 #eee;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;

    &:hover {
      background: #ccc;
    }
  `,

  // 隠しファイル入力
  HiddenFile: styled.input`
    display: none;
  `,

  // 隠しテキスト入力
  HiddenText: styled.input`
    display: none;
  `,

  // ボタンコンテナ
  ButtonContainer: styled.div`
    display: flex;
    gap: 10px;
    margin-top: 20px;
    justify-content: center;
  `,

  // レスポンシブ対応はオブジェクト定義後に追加
};

const ResponsiveContainer = styled.div`
  @media (max-width: 768px) {
    ${IraiStyles.IraiContainer} {
      width: 100%;
      padding: 15px;
    }

    ${IraiStyles.DetailTable}, ${IraiStyles.NormalTable} {
      font-size: 12px;
    }

    ${IraiStyles.DetailTable} th, ${IraiStyles.DetailTable} td {
      padding: 3px;
    }
  }
`;

IraiStyles.ResponsiveContainer = ResponsiveContainer;

export default IraiStyles;
